import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ErrorBanner } from '../ErrorBanner';
import {
  findingByIdSelector,
  findingsErrorSelector,
} from '../../../selectors/findingsSelectors';
import { clearFindingsError } from '../../../redux/actions/Findings';
import FindingSupportDetail from './FindingSupportDetail';
import FindingResolution, {
  getFormTitle,
} from './FindingResolution';

import '../../Pages/Sensor/BluSupport.scss';

/*
Component
*/

const FindingSupport = (props) => {
  const {
    dispatchClearErr,
    error,
    findingStatus,
  } = props;

  const { message: errorMsg = '' } = error || {};
  const formTitle = getFormTitle(findingStatus);

  return (
    <div className="blu-support-container">
      <div className="blu-support-container-inner">
        {error && (
        <ErrorBanner
          message={errorMsg}
          dismiss={dispatchClearErr}
        />
        )}

        <div className="blu-support-section">
          <div className="blu-support-section-title">
          Finding Details
          </div>

          <div className="blu-support-section-body">
            <FindingSupportDetail />
          </div>
        </div>

        <div className="blu-support-section">
          <div className="blu-support-section-title">
            {formTitle}
          </div>

          <div className="blu-support-section-body">
            <FindingResolution />
          </div>
        </div>
      </div>
    </div>
  );
};

FindingSupport.propTypes = {
  error: PropTypes.shape({}),
  dispatchClearErr: PropTypes.func,
  findingStatus: PropTypes.number.isRequired,
};

FindingSupport.defaultProps = {
  error: {},
  dispatchClearErr: () => {},
};

const mapStateToProps = (state) => {
  const error = findingsErrorSelector(state);

  const finding = findingByIdSelector(state);
  const { status: findingStatus } = finding;

  return ({
    error,
    findingStatus,
  });
};

const mapDispatchToProps = dispatch => ({
  dispatchClearErr: () => {
    dispatch(clearFindingsError);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FindingSupport);
